import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], keys: string[], searchValue: string): any[] {
    if (!items) return [];
    if (!keys || !searchValue) return items;

    searchValue = searchValue.toLowerCase();

    return items.filter(item => {
      return keys.some(key => {
        if (item[key] !== undefined && item[key] !== null) {
          return item[key].toString().toLowerCase().includes(searchValue);
        }
        return false;
      });
    });
  }
}
